export function event(type: string, bubbles: boolean = true, cancelable: boolean = true): Event {
    return new Event(type, {
        bubbles,
        cancelable,
    });
}
